module.exports = __webpack_public_path__ + "img/icon-locked.a1d98210.svg";